export default __webpack_public_path__ + "img/fKgkqqnP.09dc4de1.svg";